<button
  class="circle-btn"
  [matTooltip]="tooltipText | translate"
  matTooltipClass="q-tooltip"
>
  <app-icon [name]="icon"></app-icon>
</button>
